import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useMChartStatuses = defineStore('mchart-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.mChartStatus_GetMChartStatuses,
    dto: 'MChartStatusDto',
    create: api.mChartStatus_CreateMChartStatus,
    update: api.mChartStatus_UpdateMChartStatus,
    delete: api.mChartStatus_DeleteMChartStatus,
    usage: api.mChartStatus_GetUsage,
    signalR: 'MChartStatusUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
